(function() {
  'use strict';

  function hasAccessibleName(el) {
    if (!el) return false;
    var ariaLabel = (el.getAttribute('aria-label') || '').trim();
    var ariaLabelledBy = (el.getAttribute('aria-labelledby') || '').trim();
    if (ariaLabel || ariaLabelledBy) return true;

    if (el.id) {
      var explicitLabel = document.querySelector('label[for="' + el.id + '"]');
      if (explicitLabel && explicitLabel.textContent.trim()) return true;
    }

    var closestLabel = el.closest('label');
    if (closestLabel && closestLabel.textContent.trim()) return true;

    return false;
  }

  function isUnclearName(name) {
    var normalized = (name || '').trim();
    if (!normalized) return true;
    if (/^[\d\W]+$/.test(normalized)) return true;
    if (normalized.length <= 2) return true;
    if (/^(option|select|value|button|input)$/i.test(normalized)) return true;
    return false;
  }

  function getNearestContext(el) {
    var container = el.closest('[class*="customization-option"], [class*="option"], .tda-customizer-wrapper');
    if (!container) return 'Configuration option';

    var titleCandidate = container.querySelector(
      'h1, h2, h3, h4, h5, h6, legend, .tda-customizer-customization-option-title, [class*="option-title"], [class*="title"]'
    );
    if (titleCandidate && titleCandidate.textContent.trim()) {
      return titleCandidate.textContent.trim();
    }

    return 'Configuration option';
  }

  function getValueText(el) {
    if (!el) return '';
    if (el.tagName === 'SELECT' && el.options && el.selectedIndex >= 0) {
      return (el.options[el.selectedIndex].text || '').trim();
    }
    if (typeof el.value === 'string' && el.value.trim()) return el.value.trim();
    return (el.textContent || '').trim();
  }

  function labelControls(root) {
    var controls = root.querySelectorAll('input, select, textarea, button');
    controls.forEach(function(control) {
      var type = (control.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || control.disabled) return;

      if (control.classList.contains('button-minus')) {
        control.setAttribute('aria-label', 'Remove one item from cart');
        return;
      }
      if (control.classList.contains('button-plus')) {
        control.setAttribute('aria-label', 'Add one item to cart');
        return;
      }

      var existingName = (
        control.getAttribute('aria-label') ||
        control.getAttribute('title') ||
        control.value ||
        control.textContent ||
        ''
      ).trim();

      if (hasAccessibleName(control) && !isUnclearName(existingName)) return;

      var context = getNearestContext(control);
      var valueText = getValueText(control);
      var generatedLabel = valueText ? (context + ': ' + valueText) : context;
      control.setAttribute('aria-label', generatedLabel);
    });
  }

  function fixImages(root) {
    root.querySelectorAll('img').forEach(function(img) {
      var alt = (img.getAttribute('alt') || '').trim();
      var aria = (img.getAttribute('aria-label') || '').trim();
      if (alt || aria) return;

      var parentControl = img.closest('button, a');
      var parentText = parentControl ? parentControl.textContent.trim() : '';
      if (parentControl && parentText) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
        return;
      }

      var src = (img.getAttribute('src') || '').toLowerCase();
      if (src.indexOf('download') !== -1 && src.indexOf('pdf') !== -1) {
        img.setAttribute('alt', 'Download PDF');
      } else if (src.indexOf('logo') !== -1 && src.indexOf('angle3d') !== -1) {
        img.setAttribute('alt', 'Angle 3D configurator logo');
      } else {
        var nearbyHeading = img.closest('.tda-customizer-wrapper')
          ? img.closest('.tda-customizer-wrapper').querySelector('h1, h2, h3')
          : null;
        var headingText = nearbyHeading ? nearbyHeading.textContent.trim() : '';
        img.setAttribute('alt', headingText ? (headingText + ' preview image') : '3D product configuration preview image');
      }
    });
  }

  function fixAngle3dImagesGlobal() {
    var selector = [
      'img[src*="angle3d"]',
      'img[src*="fivelive.co/angle3d"]',
      'img[src*="download-pdf-icon"]',
      '[class*="tda-"] img'
    ].join(', ');

    document.querySelectorAll(selector).forEach(function(img) {
      var alt = (img.getAttribute('alt') || '').trim();
      var aria = (img.getAttribute('aria-label') || '').trim();
      if (alt || aria) return;

      var src = (img.getAttribute('src') || '').toLowerCase();
      var parentControl = img.closest('button, a');
      var parentText = parentControl ? parentControl.textContent.trim() : '';

      if (parentControl && parentText) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
        return;
      }

      if (src.indexOf('download-pdf-icon') !== -1) {
        img.setAttribute('alt', 'Download PDF');
      } else if (src.indexOf('logo-dark-gray') !== -1) {
        img.setAttribute('alt', 'Angle 3D configurator loading logo');
      } else if (src.indexOf('logo') !== -1 && src.indexOf('angle3d') !== -1) {
        img.setAttribute('alt', 'Angle 3D configurator logo');
      } else {
        var appContainer = img.closest('[class*="tda-"]');
        var containerHeading = appContainer ? appContainer.querySelector('h1, h2, h3') : null;
        var containerHeadingText = containerHeading ? containerHeading.textContent.trim() : '';
        img.setAttribute('alt', containerHeadingText ? (containerHeadingText + ' preview image') : '3D product configuration preview image');
      }
    });
  }

  function svgHasName(svg) {
    return (
      (svg.getAttribute('aria-label') || '').trim() ||
      (svg.getAttribute('aria-labelledby') || '').trim() ||
      svg.querySelector('title')
    );
  }

  function fixSvgs(root) {
    root.querySelectorAll('svg').forEach(function(svg) {
      if (svgHasName(svg)) return;

      var parentControl = svg.closest('button, a');
      var parentText = parentControl ? parentControl.textContent.trim() : '';
      if (parentControl && !parentText) {
        svg.setAttribute('aria-label', 'Icon');
        return;
      }

      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
  }

  function isFocusable(el) {
    if (!el || el.disabled) return false;
    if (el.matches('a[href], button, input, select, textarea')) return true;
    if (!el.hasAttribute('tabindex')) return false;
    return parseInt(el.getAttribute('tabindex'), 10) >= 0;
  }

  function fixAriaHiddenFocus(root) {
    root.querySelectorAll('[aria-hidden="true"]').forEach(function(el) {
      if (!isFocusable(el)) return;

      if (el.matches('a[href], button, input, select, textarea')) {
        el.removeAttribute('aria-hidden');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function runFixes() {
    var wrappers = document.querySelectorAll('.tda-customizer-wrapper');
    fixAngle3dImagesGlobal();
    if (!wrappers.length) return;

    document.querySelectorAll('.tda-app-section-model-viewer-sticky-container').forEach(function(el) {
      el.setAttribute('tabindex', '0');
    });

    wrappers.forEach(function(wrapper) {
      labelControls(wrapper);
      fixImages(wrapper);
      fixSvgs(wrapper);
      fixAriaHiddenFocus(wrapper);
    });
  }

  function init() {
    runFixes();

    var observer = new MutationObserver(function() {
      runFixes();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(runFixes, 500);
    setTimeout(runFixes, 2000);
    window.addEventListener('Angle3DCustomizerLoaded', runFixes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
